import { createContext } from 'react'

const EditorDispatch = createContext(null)
const editorReducer = (state, action) => {
  switch (action.type) {
    case 'activateTab':
      return { activeTabs: action.payload }
    default:
      return state
  }
}

export { editorReducer, EditorDispatch }
